// 星座数据
const zodiac = [
  {
    id: 1,
    name: "白羊座",
    date: "3月21日 - 4月19日",
    element: "火",
    crystals: ["红玉髓", "黄水晶", "钻石"],
    description: "白羊座的人热情、勇敢、冲动，喜欢挑战和冒险。",
    imageUrl: process.env.PUBLIC_URL + "/assets/images/products/natural_citrine_crystal_piece_on_white_background_2aa1081e.webp"
  },
  {
    id: 2,
    name: "金牛座",
    date: "4月20日 - 5月20日",
    element: "土",
    crystals: ["玫瑰石英", "绿aventurine", "蓝宝石"],
    description: "金牛座的人稳重、实际、可靠，喜欢安全感和物质享受。",
    imageUrl: process.env.PUBLIC_URL + "/assets/images/products/raw_rose_quartz_macro_view_a4d000d1.webp"
  },
  {
    id: 3,
    name: "双子座",
    date: "5月21日 - 6月20日",
    element: "风",
    crystals: ["黄水晶", "蓝玛瑙", "虎眼石"],
    description: "双子座的人聪明、好奇、适应性强，喜欢交流和学习新事物。",
    imageUrl: process.env.PUBLIC_URL + "/assets/images/products/citrine_crystal_macro_shot_0ddc20cc.webp"
  },
  {
    id: 4,
    name: "巨蟹座",
    date: "6月21日 - 7月22日",
    element: "水",
    crystals: ["月光石", "珍珠", "玫瑰石英"],
    description: "巨蟹座的人敏感、情感丰富、有保护欲，重视家庭和安全感。",
    imageUrl: process.env.PUBLIC_URL + "/assets/images/products/moonstone_ring.webp"
  },
  {
    id: 5,
    name: "狮子座",
    date: "7月23日 - 8月22日",
    element: "火",
    crystals: ["琥珀", "黄水晶", "金红石"],
    description: "狮子座的人自信、慷慨、有领导力，喜欢被关注和赞赏。",
    imageUrl: process.env.PUBLIC_URL + "/assets/images/products/citrine_earrings_on_white_background_0cb701a6.webp"
  },
  {
    id: 6,
    name: "处女座",
    date: "8月23日 - 9月22日",
    element: "土",
    crystals: ["碧玉", "绿aventurine", "橄榄石"],
    description: "处女座的人细致、实际、分析能力强，追求完美和秩序。",
    imageUrl: process.env.PUBLIC_URL + "/assets/images/products/natural_clear_quartz_cluster_on_white_background_1dcdd2b2.webp"
  },
  {
    id: 7,
    name: "天秤座",
    date: "9月23日 - 10月22日",
    element: "风",
    crystals: ["蓝宝石", "玫瑰石英", "青金石"],
    description: "天秤座的人和谐、公正、社交能力强，追求平衡和美感。",
    imageUrl: process.env.PUBLIC_URL + "/assets/images/products/rose_quartz_bracelet_on_white_background_82760464.webp"
  },
  {
    id: 8,
    name: "天蝎座",
    date: "10月23日 - 11月21日",
    element: "水",
    crystals: ["黑曜石", "石榴石", "红玉髓"],
    description: "天蝎座的人热情、坚定、洞察力强，有神秘感和强烈的情感。",
    imageUrl: process.env.PUBLIC_URL + "/assets/images/products/obsidian_stone_closeup_with_rainbow_sheen_00551ae3.webp"
  },
  {
    id: 9,
    name: "射手座",
    date: "11月22日 - 12月21日",
    element: "火",
    crystals: ["青金石", "黄水晶", "绿松石"],
    description: "射手座的人乐观、冒险、思想开放，追求自由和真理。",
    imageUrl: process.env.PUBLIC_URL + "/assets/images/products/citrine_bracelet_on_white_background_66b76e04.webp"
  },
  {
    id: 10,
    name: "摩羯座",
    date: "12月22日 - 1月19日",
    element: "土",
    crystals: ["黑曜石", "石榴石", "玛瑙"],
    description: "摩羯座的人务实、有责任感、有抱负，追求成就和稳定。",
    imageUrl: process.env.PUBLIC_URL + "/assets/images/products/black_obsidian_bracelet_on_white_background_db702a06.webp"
  },
  {
    id: 11,
    name: "水瓶座",
    date: "1月20日 - 2月18日",
    element: "风",
    crystals: ["紫水晶", "海蓝宝石", "青金石"],
    description: "水瓶座的人独立、创新、人道主义，追求进步和独特性。",
    imageUrl: process.env.PUBLIC_URL + "/assets/images/products/amethyst_geode_closeup_ca53ad8d.webp"
  },
  {
    id: 12,
    name: "双鱼座",
    date: "2月19日 - 3月20日",
    element: "水",
    crystals: ["紫水晶", "月光石", "海蓝宝石"],
    description: "双鱼座的人敏感、富有同情心、有创造力，有强烈的情感和直觉。",
    imageUrl: process.env.PUBLIC_URL + "/assets/images/products/amethyst_necklace_on_white_background_a15c3287.webp"
  }
];

export { zodiac };